import { Injectable } from '@angular/core';
import { CrudService } from '@services/crud.service';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '@services/utils.service';
import { SmsTemplate } from '../intefaces/sms-templates.interface';

@Injectable({
  providedIn: 'root'
})
export class SmsTemplatesService extends CrudService<SmsTemplate, number>{
  
  protected static BASE_API: string = `${environment.api.url}${environment.api.prefix}/messageTemplate/v1`;  

  constructor(
    protected _http: HttpClient, 
    protected utilsService: UtilsService) 
    {
      super(_http, SmsTemplatesService.BASE_API, utilsService);
    }
}
